/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Component, OnInit } from '@angular/core';
import { SessionmanagementService } from '../../../../core/services/sessionmanagement.service';
import { Router } from '@angular/router';
import { SideNavConfigService } from '../../../../core/services/sidenav-config.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PrivacyPolicyComponent } from '../../../../shared/privacy-policy/privacy-policy.component';

@Component({
  selector: 'sita-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',

})
export class HeaderComponent implements OnInit {

  headerClass = "user-color"
  isAdmin = false;
  customerName = "";
  username = "";
  userRole = "";
  isLoggedIn = false;
  docsRoute = '/app/user/documents';

  constructor(private readonly sessionSrv: SessionmanagementService, private readonly dialog: MatDialog, private readonly router: Router, private readonly sideNavSrv: SideNavConfigService) { }

  ngOnInit(): void {
    this.isAdmin = this.sessionSrv.isAdmin;
    this.headerClass = this.isAdmin ? "admin-color" : this.headerClass;
    this.isLoggedIn = this.sessionSrv.isLoggedIn();

    // Get user data from service or storage
    const userData = this.sessionSrv.getUserData();

    // Set customer_name - prioritize service property, then storage
    this.customerName = this.sessionSrv.customerName ?? userData?.customer_name ?? '';

    // Set username - prioritize service property, then storage
    this.username = this.sessionSrv.username ?? userData?.username ?? '';

    // Truncate customer name if too long
    if (this.customerName) {
      this.customerName = (this.customerName.length > 16) ? this.customerName.slice(0, 8) + '...' : this.customerName;
    }

    // Set user role
    this.userRole = this.sessionSrv.userRole ?? userData?.role ?? '';
    this.docsRoute = this.sessionSrv.isAdmin ? '/app/admin/documents' : '/app/user/documents';
  }

  exitApp() {
    this.sessionSrv.logout();
  }

  changePassword() {
    this.router.navigate(['/app/changep']);
  }

  toggleMenu() {
    const currentVal = this.sideNavSrv.toggleMenu();
    this.sideNavSrv.toggleMenu.update(() => !currentVal);
  }

  openPolicy() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '90vh';
    dialogConfig.width = '100wh';
    this.dialog.open(PrivacyPolicyComponent, dialogConfig);
  }

  navigateToReports() {
    const route = this.isAdmin ? '/app/admin/reports' : '/app/user/reports/mishandling';
    this.router.navigate([route]);
  }
 
  goToDocs(): void {
    this.router.navigateByUrl(this.docsRoute);
  }

}
